module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0046.jpg?v=5e9c8e30";